import type {
  CubeQueryFailure,
  DrillScope,
  EntityHeader,
  Found,
  InsightsQueryResult,
  ParentGrain,
  ParentHeaderRow,
} from "src/pages/ad-studio/insights/performance/types";
import {
  cubeLoad,
  useInsightsQuery,
} from "src/pages/ad-studio/insights/performance/use-insights-query";
import { toEntityHeader } from "src/pages/ad-studio/insights/performance/utils/drill";
import {
  mapFound,
  mapQueryResult,
} from "src/pages/ad-studio/insights/performance/utils/query-result";
import { parentHeaderQuery } from "src/pages/ad-studio/insights/performance/utils/query";

export function useParentEntity({
  drill,
  grain,
  id,
}: {
  drill: DrillScope;
  grain: ParentGrain;
  id: string;
}): {
  state: InsightsQueryResult<Found<EntityHeader>, CubeQueryFailure>;
} {
  const header = useInsightsQuery(
    cubeLoad({
      cube: parentHeaderQuery({ drill, grain, id }),
      wire: drill.meta.views[grain].wire,
    }),
  );
  return {
    state: mapQueryResult(
      header,
      mapFound((row: ParentHeaderRow) =>
        toEntityHeader({ header: row, drill }),
      ),
    ),
  };
}
